const VAT_INPUT_PATTERN = /^(?:100(?:\.0{1,2})?|(?:\d|[1-9]\d)(?:\.\d{1,2})?)$/;

export function parseVatInput(raw: string): number | null {
  if (!VAT_INPUT_PATTERN.test(raw)) return null;
  return Number(raw);
}

export function formatVatRate(rate: number | null | undefined): string {
  return rate == null ? '' : String(normalizeVatRate(rate));
}

export function normalizeVatRate(rate: number): number {
  if (!Number.isFinite(rate)) return 0;
  const rounded = Math.round((rate + Number.EPSILON) * 100) / 100;
  return Math.min(100, Math.max(0, rounded));
}
